import {Injectable} from '@angular/core';
import {Mutation} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class SendKeycloakInviteMutation extends Mutation {
  document = gql`
    mutation sendKeycloakInvite($keycloakId: String!) {
      sendKeycloakInvite(keycloakId: $keycloakId)
    }
  `;
}
